<template>
  <div class="stock-container-supplier">
    <!-- название -->
    <div class="store-name store-supplier">
      <!-- <div class="title-col hide-desktop">{{ $t('stock_pcs') }}</div> -->
      <span
        :class="{ 'pointer dashed-bottom': supplier.stock.shipment_days > 0 }"
        @mouseover="showSupplier = !showSupplier"
        @mouseleave="showSupplier = false"
      >{{ stockLocaleDataName }}</span>

      <transition name="fade">
        <div v-if="supplier.stock.shipment_days > 0 && showSupplier" class="transit-tooltip on-supplier">
          <span>
            {{ deliveryDeadline(supplier.stock.shipment_days_limit) }}
            {{ supplier.stock.shipment_days }}
            {{ supplier.stock.shipment_days | ending([$t('day_1'), $t('day_2'), $t('day_3')], $i18n.locale) }}
          </span>
        </div>
      </transition>
    </div>

    <!-- наличие -->
    <div class="availability">
      <span @mouseover="showSupplierAvail = !showSupplierAvail" @mouseleave="showSupplierAvail = false">{{
        supplier.amount_free | integerPart
      }}</span>
      <span class="hide-desktop">{{ $t('pcs') }}</span>

      <!-- TODO: временно отключено, использовать .dashed -->
      <!-- <transition name="fade">
            <div v-if="showSupplierAvail" class="transit-tooltip on-supplier-avail">
              <span> {{ $t('amount_updated_date') }} {{ supplier.amount_free_updated | formatDate }}</span>
            </div>
        </transition> -->
    </div>

    <!-- цена -->
    <div class="price">
      <!-- <div class="title-col hide-desktop">{{ $t('price_rub') }}</div> -->
      <span class="price-digits" v-if="supplier.price > 0">
        {{ supplier.price | integerPart }}
        <span class="small">{{ supplier.price | fractionalPart }}</span>
        <span class="hide-desktop">{{ $t('rub') }}</span>
      </span>
      <span class="price-digits" v-else-if="product.price > 0">
        {{ product.price | integerPart }}
        <span class="small">{{ product.price | fractionalPart }}</span>
        <span class="hide-desktop">{{ $t('rub') }}</span>
      </span>
      <span v-else>{{ $t('on_request') }}</span>
    </div>

    <!-- контрол +/- -->
    <div class="order order-qnt-edit">
      <div>
        <a href="#" @click.prevent="decreaseAmount"><i class="svg-icon minus icon-pointer"></i></a>
        <input-number v-model="amountCart" :value="amountCart" :min-value="0" />
        <a href="#" @click.prevent="increaseAmount"><i class="svg-icon plus icon-pointer"></i></a>
      </div>
    </div>

    <!-- кнопка добавить -->
    <div class="cart-col">
      <button
        :aria-label="$t('to_cart')"
        @click.prevent="addCart"
        :class="{ 'disabled': amountCart < 1, 'product-cart-exists': productAmountCart > 0 }"
      >
        <i class="svg-icon cart-icon"></i>
        <span v-if="productAmountCart > 0">{{ productAmountCart | integerPart }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import InputNumber from '@/components/controls/input-number';

export default {
  components: {
    InputNumber,
  },
  props: {
    supplier: {
      type: Object,
      default: {},
    },
    product: {
      type: Object,
      default: {},
    },
    initialAmount: {
      type: Number,
      default: 0,
    },
    canShowPackWarning: {
      type: Boolean,
      default: false,
    },
    searchTerm: {
      type: String,
      default: ''
    },
    searchHistory: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      amountCart: 0,
      showSupplier: false,
      showSupplierAvail: false,
    };
  },
  created() {
    if (this.initialAmount) {
      this.amountCart = this.initialAmount;
    }
  },
  computed: {
    productAmountCart() {
      return this.supplier.amount_cart;
      // return Object.values(this.product.amount_cart).reduce((a, b) => a + b, 0);
    },
    stockLocaleDataName() {
      return (
        this.supplier?.stock.stock_translations?.find((x) => x.language.slug === this.$i18n.locale)?.name ||
        this.supplier?.stock.name_1c ||
        {}
      );
    },
  },
  methods: {
    deliveryDeadline(dl) {
      if (dl === 'gt') {
        return this.$t('delivery_deadline_from');
      } else if (dl === 'lt') {
        return this.$t('delivery_deadline_to');
      }
      return this.$t('delivery_deadline');
    },
    decreaseAmount() {
      if (this.amountCart > 0) {
        let amount = this.amountCart - this.product.package_quantity;
        if (amount < 0) {
          amount = 0;
        }
        if (amount % this.product.package_quantity) {
          amount += this.product.package_quantity - (amount % this.product.package_quantity);
        }
        this.amountCart = amount;
      }
    },
    increaseAmount() {
      let amount = this.amountCart + this.product.package_quantity;
      amount -= amount % this.product.package_quantity;
      this.amountCart = amount;
    },
    addCart() {
      const data = {
        product: this.product.id,
        amount: this.amountCart,
        supplier: this.supplier.stock.id,
        price: this.supplier.price || this.product.price,
      };
      if (this.searchHistory && this.searchTerm) {
        data.search_history = this.searchHistory.id;
        data.search_term = this.searchTerm;
      }
      this.$axios
        // .$post('/order/add-cart-supplier/', data)
        .$post('/order/update-cart/', data)
        .then((response) => {
          this.$store.dispatch('setCartExists');
          if (!response.amount_free && (this.express || this.hidePreorder)) {
            this.$emit('fetch-products');
          } else {
            this.supplier.amount_free = response.amount_free;
            this.supplier.amount_cart = response.amount_cart;
          }
          this.amountCart = 0;
          this.$notify({
            duration: 1000,
            text: this.$t('product_added_to_cart'),
          });
        })
        .catch((e) => {
          let msg = this.$t('unknown_error');
          try {
            msg = e.response.data.detail;
          } catch (e) {
          } finally {
            this.$notify({
              duration: 5000,
              text: msg,
            });
          }
        });
    },
  },
};
</script>
